import React, { FC } from 'react';
import classNames from 'classnames';

interface IconProps {
  className?: string;
}

export const AlertTriangle: FC<React.PropsWithChildren<IconProps>> = ({ className }) => (
  <svg className={classNames([className])} width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M82.8298 88.0005H13.1698C7.04477 88.0005 3.14977 81.4406 6.08477 76.0656L40.9148 12.2055C43.9748 6.59555 52.0248
       6.59555 55.0848 12.2055L89.9148 76.0605C92.8498 81.4405 88.9548 87.9956 82.8298 87.9956V88.0005Z"
      fill="url(#paint0_linear_688_11295)"
    />
    <path
      d="M50.9451 63.2353H45.1251L41.9951 39.2303V28.0303H53.9951V39.2303L50.9401
      63.2353H50.9451ZM42.0001 80.0003V68.0003H54.0001V80.0003H42.0001Z"
      fill="#121212"
    />
    <defs>
      <linearGradient id="paint0_linear_688_11295" x1="18.8648" y1="27.7005" x2="63.3048" y2="104.676" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CAE2FF" />
        <stop offset="0.75" stopColor="#006AFF" />
      </linearGradient>
    </defs>
  </svg>
);
